import gql from 'graphql-tag';

import DAILY_COMPACT_FRAGMENT from './DAILY_COMPACT_FRAGMENT';

const GET_SERVICE_RUN_DAILY_COMPACT = gql`
	query($id: String) {
		getServiceRun(id: $id) {
			...serviceRunDailyCompact
		}
	}
	${DAILY_COMPACT_FRAGMENT}
`;

export default GET_SERVICE_RUN_DAILY_COMPACT;
